import { Stack, Typography } from "@mui/material";
import Switch from "@mui/material/Switch";
import * as React from "react";

const TemplateSwitch = ({
    value,
    setValue,
    options,
    enabled = true,
}: {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    options: { name: string; value: string }[];
    enabled?: boolean;
}) => {
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography sx={{ fontSize: 12 }}>{options[0].name}</Typography>
            <Switch
                disabled={!enabled}
                checked={value === options[1].value}
                onChange={() => {
                    if (value === options[0].value) {
                        setValue(options[1].value);
                    } else {
                        setValue(options[0].value);
                    }
                }}
                size="small"
            />
            <Typography sx={{ fontSize: 12 }}>{options[1].name}</Typography>
        </Stack>
    );
};

export default TemplateSwitch;
